import useQuestionCategories from '@v4/hooks/questions/useQuestionCategories'
import { useMemo } from 'react'

export const useCategoryInfo = ({ showCategory, align, withShadow }) => {
	const categories = useQuestionCategories()

	const title = useMemo(() => {
		return _.map(categories, category => category.title).join(', ')
	}, [categories])

	return [
		{
			title,
			showCategory,
			align,
			withShadow,
		},
	]
}
